import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { api, ApiError } from '../lib/api';
import { useAuth } from '../lib/auth';

export function LoginPage() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [remember, setRemember] = useState(false);
  const [err, setErr] = useState('');
  const [busy, setBusy] = useState(false);
  const nav = useNavigate();
  const { refresh, me } = useAuth();

  if (me) nav('/', { replace: true });

  async function onSubmit(e: React.FormEvent) {
    e.preventDefault();
    setErr(''); setBusy(true);
    try {
      const r = await api.post<{ mfaRequired: boolean; mustChangePassword: boolean }>(
        '/auth/login', { email, password, remember },
      );
      await refresh();
      if (r.mfaRequired) nav('/2fa');
      else if (r.mustChangePassword) nav('/passwort-aendern');
      else nav('/2fa-setup');
    } catch (e) {
      setErr(e instanceof ApiError ? e.message : 'Login fehlgeschlagen');
    } finally { setBusy(false); }
  }

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-rla-50 to-slate-100 p-4">
      <div className="card w-full max-w-md">
        <div className="flex flex-col items-center gap-2 mb-6">
          <img src="/rla-logo.png" alt="RLA Solutions" className="h-20 w-auto object-contain" />
          <div className="text-center">
            <h1 className="text-xl font-bold text-rla-700">Mail</h1>
            <p className="text-xs text-slate-500">Sichere Anmeldung</p>
          </div>
        </div>
        <form onSubmit={onSubmit} className="space-y-4">
          <div>
            <label className="label">E-Mail</label>
            <input type="email" className="input" autoComplete="username" required value={email} onChange={(e) => setEmail(e.target.value)} />
          </div>
          <div>
            <label className="label">Passwort</label>
            <input type="password" className="input" autoComplete="current-password" required value={password} onChange={(e) => setPassword(e.target.value)} />
          </div>
          <label className="flex items-center gap-2 text-sm text-slate-600">
            <input type="checkbox" checked={remember} onChange={(e) => setRemember(e.target.checked)} className="rounded border-slate-300" />
            Auf diesem Gerät angemeldet bleiben
          </label>
          {err && <div className="bg-red-50 border border-red-200 text-red-700 text-sm rounded-md p-3">{err}</div>}
          <button type="submit" disabled={busy} className="btn-primary w-full">
            {busy ? 'Anmelden …' : 'Anmelden'}
          </button>
        </form>
      </div>
    </div>
  );
}
